"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("curry"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
const count = (0, _curry.default)(data => {
  if (!data) return 0;
  if (Array.isArray(data) || (0, _isString.default)(data)) return data.length;
  if ((0, _isObject.default)(data)) return Object.keys(data).length;
  if (!isNaN(data)) return data;
  return 0;
});
var _default = exports.default = count;